import { useState, useEffect } from "react";
import { getApiURL } from "../config/api";
import { useSelectedHost } from "@tellescope/ui";

// Custom event for host changes
const HOST_CHANGE_EVENT = "tellescope-host-changed";

interface DevBannerProps {
  onClose: () => void;
}

export const DevBanner: React.FC<DevBannerProps> = ({ onClose }) => {
  const [selectedHost, setSelectedHost] = useSelectedHost();
  const [currentApiUrl, setCurrentApiUrl] = useState(() => getApiURL(selectedHost));

  // Listen for custom host change events
  useEffect(() => {
    const updateHostInfo = () => {
      const apiUrl = getApiURL(selectedHost);
      setSelectedHost(selectedHost);
      setCurrentApiUrl(apiUrl);
    };

    // Listen for custom host change events
    window.addEventListener(HOST_CHANGE_EVENT, updateHostInfo);

    // Also listen for storage events (in case another tab changes the host)
    window.addEventListener("storage", (e) => {
      if (e.key === "tellescope-dev-host") {
        updateHostInfo();
      }
    });

    return () => {
      window.removeEventListener(HOST_CHANGE_EVENT, updateHostInfo);
      window.removeEventListener("storage", updateHostInfo);
    };
  }, [selectedHost, setSelectedHost]);

  return (
    <div className="w-full h-8 bg-yellow-400 text-black text-xs py-1 px-4 flex items-center justify-center gap-2 border-b border-yellow-500 flex-shrink-0">
      <span className="font-semibold">🔧 DEV MODE</span>
      <span>•</span>
      <span>
        Host: <strong>{selectedHost.name}</strong>
      </span>
      <span>•</span>
      <span>
        API: <strong>{currentApiUrl}</strong>
      </span>
      <button
        onClick={onClose}
        className="ml-4 p-1 hover:bg-yellow-500 rounded transition-colors duration-150 flex items-center justify-center w-5 h-5"
        aria-label="Close dev banner"
        title="Close dev banner"
      >
        ×
      </button>
    </div>
  );
};
